import { Navigate, useLocation } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { useAppSelector } from "@/redux/hooks";
import { selectIsOnboardingComplete } from "@/redux/slices/quickSetup";

export const Home = () => {
  const operator = useOperator();
  const location = useLocation();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const isAdmin = operator.roles.includes("Fa_Access") || operator.roles.includes("Owner") || operator.roles.includes("Admin");

  const isAlreadyInOperatorPath = location.pathname.includes(`/operator/${operator.id}`);

  if (!isAdmin) {
    const path = isAlreadyInOperatorPath ? "bookings" : `operator/${operator.id}/bookings`;
    return <Navigate to={path} />;
  }

  if (isOnboardingComplete === null) {
    return <Loading />;
  }

  const destination = isOnboardingComplete ? "bookings" : "quick-setup";
  const path = isAlreadyInOperatorPath ? destination : `operator/${operator.id}/${destination}`;

  return <Navigate to={path} />;
};
